import MessageEventList from "go-component/components/MessageEvent/MessageEventList";
import { parseApiData } from "go-core/api/parseApiData";
import { api } from "../../../../../../../../../../services/Security/api";

const UserLogsMessageEventsIndexPage = () => {
	const getUsers = async (search: string, params: Record<string, any>, options?: Record<string, any>) => {
		const newParams = { ...params };

		delete newParams.ids;

		const response = await parseApiData(
			api.user().getUsersSearchSelect(search, newParams, { cancelToken: options?.token })
		);

		return response.map(({ email }: Record<string, any>) => ({ label: email, id: email }));
	};

	return <MessageEventList getUsers={getUsers} organization_name={""} />;
};
export default UserLogsMessageEventsIndexPage;
